<div class="d-flex flex-column justify-content-center align-items-center p-3" >
    <div style="font-size: 1.5em; font-weight: bold; text-decoration: underline;" class="mb-4">
        <i class="fa-solid fa-link"></i> {{title}}
    </div>
    <div class="w-100 d-flex justify-content-start align-items-center">
        <div class="mr-2 " style="border-radius: 50%; overflow: hidden;">
            <img src="../../../../../assets/images/w.jpeg" />
        </div>
        <div class="d-flex justify-content-center h-100 flex-column align-items-start">
            <span style="padding: 1em 2em; border: 3px dashed var(--primary); color: black; border-radius: 10px;" class="mb-4">{{linkToBeShared}}</span>
            <div class="d-flex w-100 justify-content-center " style="font-size: .8em;">
                <button (click)="copyLink()" class="my-button-3 mr-2"><i class='fa fa-copy'></i> Copy</button>
                <button (click)="shareLink()" class="my-button"><i class="fa-brands fa-whatsapp"></i> Share</button>
            </div>
        </div>

    </div>
   
  

</div>